import { createSelector } from 'reselect'
import { List, Set } from 'immutable'
import * as MessageSelectors from 'app/modules/message/selectors'

export const getCardState = (state) => state.get('cards')
export const getHrefsByMessageId = (state) => getCardState(state).hrefsByMessageId
export const getCardsByHref = (state) => getCardState(state).cardsByHref

const EMBED_VIDYARD = "https://embed.vidyard.com"
const SUPPORTED_PLAYER_SITES = Set([
  'YouTube',
  'Vimeo',
  'ViewedIt',
  'Vidyard',
  'Vidyard GoVideo',
  'Wistia, Inc.',
  'GIPHY'
])

export const makeMessageHrefs = (latestEditMessageSelector = MessageSelectors.makeLatestEditMessageSelector()) => createSelector(
  [
    (state, { message: { conversationId, id }}) => latestEditMessageSelector(state, { conversationId, messageId: id }),
    getHrefsByMessageId,
    (state, props) => props
  ],
  (latestEditMessage, getHrefsByMessageId, props) => {
    const { id } = props.message
    return getHrefsByMessageId.get(latestEditMessage ? latestEditMessage.id : id, List())
  })


export const makeGetCardsByMessageId = (messageHrefs = makeMessageHrefs()) => createSelector(messageHrefs, getCardsByHref,
  (messageHrefs, cardsByHref) => {
    return messageHrefs
      .map((href) => cardsByHref.get(href))
      .filter((cardAndStatus) => !!cardAndStatus && cardAndStatus.status === 'success')
      .map((cardAndStatus) => cardAndStatus.card)
      .filter((card) => {
        const primaryRel = card.primaryRel
        if (primaryRel === 'summary') {
          return true
        }
        if (primaryRel === 'player') {
          return SUPPORTED_PLAYER_SITES.has(card.meta.site) || (card.meta.canonical && card.meta.canonical.includes(EMBED_VIDYARD))
        }
        return false
      })
  }
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/cards/selectors.js